<!-- top section-->
<div class="pos-relative z-2 p-t-4 p-b-4 p-t-5-s p-b-5-s p-r-6 p-l-6 flex flex-justify-right flex-middle"
     style="box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);">
    <!-- hide button -->
    <button class="cursor-pointer right"
            [attr.aria-label]="'Close' | translate"
            (click)="hide()">
        <i class="icon-close col-11 fs-4"
           aria-hidden="true"></i>
    </button>
</div>
<!-- content -->
<div class="w-12 pos-relative  shipping-methods flex"
     style="height: 100%;padding-bottom:4rem;"
     [offClickOff]="!isVisible"
     (offClick)="hide()">
    <div class="w-12 pos-relative overflow-y-auto scrollbar-none left p-a p-l-6 p-r-6 flex flex-column flex-grow">
        @if (isVisible && checkoutFormComponent) {
        <giftbox-form class="w-12"
                      [boxId]="boxId"
                      [checkoutFormComponent]="checkoutFormComponent" />
        }
    </div>
</div>